<template>
  <v-card>
    <v-card-title>Пополнение баланса</v-card-title>
    <v-card-text>
      <v-text-field
        v-model.number="amount"
        label="Сумма пополнения (руб.)"
        type="number"
        min="1"
        :rules="amountRules"
        outlined
      ></v-text-field>
      <v-alert v-if="error" type="error" class="mt-2">{{ error }}</v-alert>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="$emit('cancel')">Отмена</v-btn>
      <v-btn
        color="primary"
        @click="handleTopup"
        :loading="loading"
        :disabled="!isValidAmount"
      >
        Пополнить
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import NSApi from "@/api/NSApi";

export default {
  name: "BalanceTopupModal",
  data() {
    return {
      amount: null,
      loading: false,
      error: null,
      amountRules: [
        (v) => !!v || "Укажите сумму",
        (v) => v > 0 || "Сумма должна быть больше 0",
        (v) => v <= 1000000 || "Сумма не должна превышать 1 000 000 руб.",
      ],
    };
  },
  computed: {
    isValidAmount() {
      return this.amount && this.amount > 0 && this.amount <= 1000000;
    },
  },
  methods: {
    async handleTopup() {
      if (!this.isValidAmount) return;

      this.loading = true;
      this.error = null;

      try {
        const response = await NSApi.instance.createBalanceTopup(this.amount);

        if (response.confirmation_url) {
          window.location.href = response.confirmation_url;
        } else {
          this.error = "Не удалось получить ссылку для оплаты";
        }
      } catch (error) {
        console.error("Ошибка при создании пополнения:", error);
        this.error =
          error.response?.data?.error || "Ошибка при создании пополнения";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
